import { useEffect } from 'react';
import useRouter from 'useRouterCompat';
import { useData } from 'resift';
import getAppVersionStatus from 'fetches/getAppVersionStatus';

export default function useUpdateApp() {
  const { history } = useRouter();
  const { isCompatible, recommendUpdate } = useData(getAppVersionStatus) || {};

  useEffect(() => {
    history.listen(({ pathname }: { pathname: string }) => {
      if (isCompatible === false || recommendUpdate) {
        window.location.reload();
      }
    });
  }, [history, isCompatible, recommendUpdate]);
}
